import { ClipboardCopyIcon, CodeIcon } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Modal } from "@/components/ui/modal";
import { Text } from "@/components/ui/text";

type InsightsViewSqlButtonProps = {
  sql: string;
  rejected?: boolean;
};

export function InsightsViewSqlButton({
  sql,
  rejected = false,
}: InsightsViewSqlButtonProps) {
  const [open, setOpen] = React.useState(false);

  return (
    <DialogTrigger isOpen={open} onOpenChange={setOpen}>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 gap-1 px-2 text-xs text-muted-foreground"
      >
        <CodeIcon className="size-3.5" />
        View SQL
      </Button>
      <Modal size="2xl">
        <Dialog aria-label={rejected ? "Rejected SQL" : "Generated SQL"}>
          <DialogHeader>
            <DialogTitle>
              {rejected ? "Generated SQL (rejected)" : "Generated SQL"}
            </DialogTitle>
            <Text size="2" muted>
              For debugging — end users usually do not need this.
            </Text>
          </DialogHeader>
          <DialogBody>
            <pre className="max-h-[min(60vh,400px)] overflow-auto rounded-md border bg-muted/30 p-3 text-xs font-mono whitespace-pre-wrap">
              {sql}
            </pre>
          </DialogBody>
          <DialogFooter>
            <Button
              variant="outline"
              size="sm"
              onPress={() => {
                void navigator.clipboard.writeText(sql);
              }}
            >
              <ClipboardCopyIcon />
              Copy SQL
            </Button>
          </DialogFooter>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
}
